import AutocompleteField from "../../../shared/forms/AutocompleteField";

const inputClass =
  "mt-1 block w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm outline-none transition focus:border-amber-500 focus:ring-2 focus:ring-amber-500/20";

const brothers = [
  "No Brothers",
  "1 Brother - Married",
  "1 Brother - Unmarried",
  "2 Brothers - Married",
  "1 Brother Married, 1 Brother Unmarried",
  "2 Brothers - Unmarried",
  "More than 2 Brothers",
];

const sisters = [
  "No Sisters",
  "1 Sister - Married",
  "1 Sister - Unmarried",
  "2 Sisters - Married",
  "1 Sister Married, 1 Sister Unmarried",
  "2 Sisters - Unmarried",
  "More than 2 Sisters",
];

const Field = ({
  label,
  children,
}) => (
  <label className="block text-sm font-medium text-slate-700">
    {label}
    <span className="ml-1 text-red-600">*</span>
    {children}
  </label>
);

const FamilyDetailsSection = ({
  formData,
  updateField,
  setFieldValue,
  searchProfessions,
}) => (
  <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
    <Field label="Father's Name">
      <input
        name="fatherName"
        value={formData.fatherName || ""}
        onChange={updateField}
        className={inputClass}
      />
    </Field>

    <AutocompleteField
      label="Father's Profession"
      required
      value={
        formData.fatherProfession
      }
      searchFn={searchProfessions}
      placeholder="Start typing profession"
      onChange={(value) =>
        setFieldValue(
          "fatherProfession",
          value
        )
      }
    />

    <Field label="Mother's Name">
      <input
        name="motherName"
        value={formData.motherName || ""}
        onChange={updateField}
        className={inputClass}
      />
    </Field>

    <AutocompleteField
      label="Mother's Profession"
      required
      value={
        formData.motherProfession
      }
      searchFn={searchProfessions}
      placeholder="Start typing profession"
      onChange={(value) =>
        setFieldValue(
          "motherProfession",
          value
        )
      }
    />

    <Field label="No. of Brothers">
      <select
        name="noOfBrothers"
        value={formData.noOfBrothers || ""}
        onChange={updateField}
        className={inputClass}
      >
        <option value="">
          Select
        </option>
        {brothers.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </Field>

    <Field label="No. of Sisters">
      <select
        name="noOfSisters"
        value={formData.noOfSisters || ""}
        onChange={updateField}
        className={inputClass}
      >
        <option value="">
          Select
        </option>
        {sisters.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </Field>

    <Field label="Family Status">
      <select
        name="familyStatus"
        value={formData.familyStatus || ""}
        onChange={updateField}
        className={inputClass}
      >
        <option value="">Select</option>
        <option value="Middle Class">Middle Class</option>
        <option value="Upper Middle Class">Upper Middle Class</option>
        <option value="Rich">Rich</option>
        <option value="Affluent">Affluent</option>
      </select>
    </Field>

    <Field label="Family Type">
      <select
        name="familyType"
        value={formData.familyType || ""}
        onChange={updateField}
        className={inputClass}
      >
        <option value="">Select</option>
        <option value="Nuclear">Nuclear</option>
        <option value="Joint">Joint</option>
        <option value="Extended">Extended</option>
      </select>
    </Field>

    <Field label="Family Values">
      <select
        name="familyValues"
        value={formData.familyValues || ""}
        onChange={updateField}
        className={inputClass}
      >
        <option value="">Select</option>
        <option value="Traditional">Traditional</option>
        <option value="Moderate">Moderate</option>
        <option value="Modern">Modern</option>
        <option value="Liberal">Liberal</option>
      </select>
    </Field>
  </div>
);

export default FamilyDetailsSection;
